import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, ConfirmationService } from 'primeng/primeng';

import { Ng2BRPipesModule } from 'ng2-brpipes';

import { EmpregoNaPistaSharedModule } from '../shared/emprego-na-pista-shared.module';
import { FaseUnidadeService } from './faseUnidade.service';

@NgModule({
  imports: [
      BrowserModule,
      FormsModule, ReactiveFormsModule,

      ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule,

      Ng2BRPipesModule,

      EmpregoNaPistaSharedModule
  ],
  providers: [ FaseUnidadeService, ConfirmationService ],
  declarations: [
      // CadastrarEditarFaseComponent,
      // GerenciarFaseComponent,
      // VisualizarFaseComponent,
  ],
})
export class FaseUnidadeModule { }



// WEBPACK FOOTER //
// ./src/app/components/faseUnidade/faseUnidade.module.ts